module.exports = __webpack_public_path__ + "img/mic.14abd65a.svg";